import React, { useEffect, useCallback } from "react";
import {
  makeStyles,
  MenuItem,
  Card,
  CardContent,
  CardMedia,
  Button,
  Typography,
  TextField,
  CircularProgress,
  Box,
  Container,
} from "@material-ui/core";
import * as Yup from "yup";
import * as usernameauthActions from "src/redux/actions/usernameauth.action";
import * as loginActions from "src/redux/actions/login.action";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Field, Formik } from "formik";
import Alert from "@material-ui/lab/Alert";
import Page from "src/components/Page";
import { TextField as TextFieldMik } from "formik-material-ui";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  media: {
    height: 140,
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
}));

export default function Login(props) {
  const classes = useStyles();

  const loginReducer = useSelector((state) => state.loginReducer);

  const dispatch = useDispatch();

  const { countries } = useSelector(
    (state) => state.userauthReducer,
    shallowEqual
  );

  useEffect(() => {
    dispatch(usernameauthActions.setStateClearCountries());
    return () => {};
  }, []);

  const renderProgressLogin = () => {
    if (loginReducer.isFetching) {
      return <CircularProgress color="secondary" />;
    }
    return "Sign In";
  };

  const loginSubmit = useCallback(
    (values) => {
      const {
        usernameauth,
        password,
        countries: {
          ORG_COUNTRY_ID,
          ORG_COMPANY_ID,
          CURRENCY_CODE,
          CURRENCY_NAME,
          Company,
          COMPANY_CODE,
          COUNTRY,
          COUNTRY_IMG,
          Country_Code,
          CURRENCY_ID,
        },
      } = values;

      dispatch(
        loginActions.login(
          usernameauth,
          password,
          ORG_COUNTRY_ID,
          ORG_COMPANY_ID,
          CURRENCY_CODE,
          CURRENCY_NAME,
          Company,
          COMPANY_CODE,
          COUNTRY,
          Country_Code,
          COUNTRY_IMG,
          CURRENCY_ID,
          props.history
        )
      );
    },
    [dispatch]
  );

  return (
    <Page className={classes.root} title="Login">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Card>
          <CardContent>
            <Container maxWidth="sm">
              <Formik
                initialValues={{
                  usernameauth: "",
                  password: "",
                  country_id: 58,
                  companyId: 0,
                }}
                validationSchema={Yup.object().shape({
                  usernameauth: Yup.string().required("Username is required"),
                  password: Yup.string().required("Password is required"),
                  country_id: Yup.string().required("Country is required"),
                })}
                onSubmit={(values) => {
                  let result = _.find(countries, {
                    ORG_COUNTRY_ID: values.country_id,
                  });
                  if (result) {
                    values.countries = result;
                  }
                  loginSubmit(values);
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  touched,
                  values,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box mb={1}>
                      <Card>
                        <CardMedia
                          className={classes.media}
                          image={`${process.env.PUBLIC_URL}/images/authen_header.jpg`}
                          title="Contemplative Reptile"
                        />
                      </Card>
                      <br></br>
                      <Typography
                        color="textSecondary"
                        gutterBottom
                        variant="body2"
                        align="center"
                      >
                        Login to Budget & Financial Control System
                      </Typography>
                      <Typography
                        color="textSecondary"
                        gutterBottom
                        variant="body2"
                        align="center"
                      >
                        / Purchase Requisition System
                      </Typography>
                    </Box>
                    <TextField
                      error={Boolean(
                        touched.usernameauth && errors.usernameauth
                      )}
                      helperText={touched.usernameauth && errors.usernameauth}
                      variant="outlined"
                      margin="normal"
                      name="usernameauth"
                      fullWidth
                      onBlur={(e) => {
                        e.preventDefault();
                        if (values.usernameauth) {
                          dispatch(
                            usernameauthActions.getUserauth(values.usernameauth)
                          );
                        }
                        handleBlur(e);
                      }}
                      onChange={handleChange}
                      value={values.usernameauth}
                      label="Username"
                      autoComplete="username"
                      autoFocus
                    />
                    <TextField
                      error={Boolean(touched.password && errors.password)}
                      fullWidth
                      helperText={touched.password && errors.password}
                      label="Password"
                      margin="normal"
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="password"
                      value={values.password}
                      variant="outlined"
                    />
                    <Field
                      component={TextFieldMik}
                      name="country_id"
                      onChange={handleChange}
                      error={Boolean(
                        errors.country_id &&
                          touched.country_id &&
                          errors.country_id
                      )}
                      fullWidth
                      disabled={countries.length > 0 ? false : true}
                      variant="outlined"
                      label="Please Select Country"
                      margin="normal"
                      select
                    >
                      {countries &&
                        countries.map((item) => (
                          <MenuItem
                            key={item.ORG_COUNTRY_ID}
                            value={item.ORG_COUNTRY_ID}
                          >
                            {item.COUNTRY} ( {item.Company} ){" "}
                          </MenuItem>
                        ))}
                    </Field>
                    <Box my={2}>
                      <Button
                        color="primary"
                        disabled={isSubmitting}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                      >
                        {renderProgressLogin()}
                      </Button>
                    </Box>
                    <Typography
                      color="textSecondary"
                      variant="body1"
                      align="center"
                    >
                      Login with your Windows Logon credential.
                    </Typography>
                    {loginReducer.error && (
                      <Alert
                        severity="error"
                        style={{
                          color: "gray",
                          marginTop: 10,
                          marginBottom: 10,
                        }}
                      >
                        {loginReducer.result}
                      </Alert>
                    )}
                  </form>
                )}
              </Formik>
            </Container>
          </CardContent>
        </Card>
      </Box>
    </Page>
  );
}
